import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';
import { outline } from './constants';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiButtonBase']
>['styleOverrides'] = {
  root: ({ theme }) => ({
    [`@media screen and (max-width:${theme.breakpoints.values.sm}px)`]: {
      '&.MuiButton-sizeSmall': {
        lineHeight: '2.25',
      },
      '&.MuiButton-sizeMedium': {
        lineHeight: '2.3',
      },
      '&.MuiButton-sizeLarge': {
        lineHeight: '2.35',
      },
    },

    '&:focus-visible': {
      outline,
    },

    '&.MuiIconButton-root': {
      padding: theme.spacing(1),
    },

    '&.MuiTab-root': {
      fontSize: '1em',
      textTransform: 'capitalize',

      '&.Mui-selected': {
        fontWeight: 500,
      },

      '&:hover': {
        color: theme.vars.palette.primary.main,
      },
    },
  }),
};

const MuiButtonBase: Components<CssVarsTheme>['MuiButtonBase'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides,
};

export default MuiButtonBase;
